export default {

  /* 全局 */
  '全局/系统接口异常': (s) => `系统接口${s}异常`,

  /* 抄表结算 */
  '抄表结算/注说明': '注: 甲方支付给乙方的月度储能系统服务费为峰谷价差收益之和。电表计量基于储能系统并网点电表的测量值，对应的峰谷时段电价为当地电力部门执行的实际电价。具体计算公式如下:\n1. 放电费用 = ∑(放电电量 × 对应时段电价)\n2. 充电费用 = ∑(充电电量 × 对应时段电价)\n3. 峰谷价差收益 = 放电费用 - 充电费用\n4. 储能系统收益 = 峰谷价差收益',

  /* 告警管理 */
  '告警管理/告警码删除提示': (code) => `确定要删除告警码${code}吗？`,

  /* 负荷跟踪 */
  '负荷跟踪/删除提示': (s) => `确定要删除${s}吗？`,

  /* 运行策略 */
  '运行策略/预约策略保存提示': (s)  =>`请先保存“${s}”`,
  '运行策略/预约策略生效提示': (s, d) => `距离“${s}”生效还有${d}天`,
  '运行策略/生效日期重复提示': (s) => `生效日期与${s}重复`,
  '运行策略/策略类型修改记录': (d, t) => `将 ${d} 的策略修改为 "${t}策略"`,
  '运行策略/充放电计划修改记录': (o, n) => `将充放电计划由 "${o}" 修改为 "${n}"`,
  '运行策略/需量变更记录': (o, n) => `将需量由 "${o}" 修改为 "${n}"`,
  '运行策略/模式修改记录': (m) => `将模式改为"${m}"`,

  /* 时段电价 */
  '时段电价/时段电价设置提示': '正在设置时段电价，第1步：多选左侧日期，第2步：配置右侧电价。双击左侧日期可将电价填入表格',


  /* 设备型号 */
  '设备型号/删除提示': (names) => `是否确认删除型号[${names}]吗?`,
  
}
